module.exports = __webpack_public_path__ + "static/media/dumbbell-white.db3e2aa0.svg";